export default __webpack_public_path__ + "static/media/bluetick.03d7fe15.png";